import React from "react"
import { navigateTo } from "gatsby-link"
import { Heading, NavLink } from "rebass"
import styled, { withComponent } from "styled-components"

import colors from "../../config/colors.js"

const A = styled(NavLink)`
  color: ${props => (props.scrolled ? colors.gray : "black")};
  background-color: ${props => (props.active && props.scrolled ? colors.secondaryDark : props.active ? "rgba(20,20,20,0.2)" : "transparent")};
  font-size: 14px;
  &:hover {
    background-color: ${props => (props.scrolled ? colors.secondaryDark : "rgba(20, 20, 20, 0.2)")};
  }

`.withComponent(({ active, ...rest }) => <NavLink {...rest} />)

const NavbarLink = ({ to, href, onClick, children, location, scrolled }) => (
  <A
    scrolled={scrolled}
    py={3}
    active={location && location.pathname === to}
    onClick={() => {
      onClick()
    }}
    href={href}
  >
    <Heading fontSize={1}>{children}</Heading>
  </A>
)

export default NavbarLink



// WEBPACK FOOTER //
// ./src/components/NavbarLink/index.js